import _ from 'lodash';
import { AUTH_SERVER, AUTH_ENDPOINTS, BILLING_SERVER, BILLING_ENDPOINTS } from '@services/servers';
import { graphQuery, postRequest } from '@services/commService';
import { cognitoChangePassword } from '@services/cognitoUserService';


export const getUserData = async () => {
  const query = `
  {
    users {
      id
      fullName
      email
      birthdate
      self
      plans{
        planId
        nextCharge
        status
        chargeFrequency
        price{
          amount
          currency
        }
      }
    }
    entityCourses {
      name
      Subscription{
        type
      }
    }
  }
  `;
  const res = await graphQuery(query, true);
  const { users, entityCourses } = res.data;
  const selfUser = _.find(users, { self: true });
  return { user: selfUser, course: entityCourses[0] };
};

export const changePassword = async (oldPassword, newPassword) => {
  const result = await cognitoChangePassword({ oldPassword, newPassword });
  if (result?.success) {
    // Best-effort: update password-changed timestamp in Cognito (admin-managed attribute).
    // Do not fail the UI if this sync call fails.
    try {
      await postRequest(AUTH_SERVER, AUTH_ENDPOINTS.PASSWORD_CHANGED_AT, null, 'json');
    } catch (_) {
      // ignore
    }
    return { data: true };
  }
  return {
    error: {
      code: result?.error?.code || result?.error?.name || result?.error?.__type,
      message: result?.error?.message || 'Failed to change password',
    },
  };
};

export const cancelSubscription = async (planId) => {
  try {
    const response = await postRequest(
      BILLING_SERVER, BILLING_ENDPOINTS.CANCEL_SUBSCRIPTION,
      { planId });
    return response.body;
  } catch (error) {
    throw (new Error(error.message));
  }
};
